export class PlazoDTO {
    constructor(public inicio: string, public termino: string) {
        this.inicio = inicio;
        this.termino = termino;
    }
}
